<!-- Editable Form -->
<form [formGroup]="machineLimitForm" novalidate *ngIf="!isReadOnlyMode">
  <div class="machine-limit-container">
    <div class="button-container" style="display: flex; align-items: center; gap: 10px;">
      <ion-label id="hideInRaReportLabel">{{ 'hide_in_ra_report' | translate }}</ion-label>
      <ion-toggle
        class="hide-in-ra-toggle"
        [checked]="isLimitVisible"
        color="primary"
        (ionChange)="onToggleChange($event)"
        appAccessibleToggle
        [appAccessibleToggleLabelledBy]="'hideInRaReportLabel'"
        [tooltip]="isLimitVisible ? ('toggle_hide_limits_tooltip' | translate) : ''" 
        placement="bottom"></ion-toggle>
      <ion-button class="app-btn margin-right-16" *ngIf="!isCloneMode" shape="round" fill="outline" color="primary" (click)="cancel()">
        {{'Cancel'|translate}}
      </ion-button>
      <ion-button class="app-btn" *ngIf="!isCloneMode" shape="round" fill="outline" color="primary" (click)="saveMachineLimits()">
        {{'Save'|translate}}
      </ion-button>
    </div>
    <div class="machine-limit-block">
    <div class="section-block">
      <div class="section-header">
        <span class="section-title">{{'use_limits' | translate}}</span>
        <div class="section-line"></div>
      </div>
    </div>
    <div class="form-grid-container">
      <div class="form-column-left">
        <ion-label class="label-class"> {{ 'Machine Mode' | translate }} *</ion-label>
        <ng-select [items]="sharedValue?.machineModeList" bindLabel="name" bindValue="id" [loading]="getMachineModesLoading"
          [clearable]="true" formControlName="machineMode" [multiple]="true" [selectableGroup]="true" [closeOnSelect]="false"
          [searchable]="true" placeholder="{{'select_machine_mode'|translate}}" class="select-dropdown"
          (remove)="onRemoveMachineMode($event)" (clear)="onClearAll($event)">
          <ng-template ng-option-tmp let-item="item" let-item$="item$.selected" let-index="index">
            <label [for]="'source-item-' + index">
              <input id="source-item-{{index}}" type="checkbox" [attr.aria-label]="item.name"
                [ngModelOptions]="{standalone: true}" [ngModel]="item$" />
              {{item.name}}
            </label>
          </ng-template>
        </ng-select>
        <ion-text *ngIf="shouldShowError('machineMode') && machineMode?.hasError('required')" color="danger">
          {{ 'machine_mode_required' | translate }}
        </ion-text>
      </div>
      <div class="form-column-right">
        <ion-label class="label-class"> {{ 'use_of_machinery' | translate }} </ion-label>
        <app-ai-writing-field-shell formControlName="useOfMachinery" class="ai-text-area-block" title="{{ 'use_of_machinery' | translate }}" placeholder="{{'enter_description' | translate}}" fieldContextType="machine-limit-description" [historyKey]="'machine-limit::' + machineId + '::useOfMachinery'"></app-ai-writing-field-shell>
        <!-- Uncomment below to show character count display -->
        <!-- <div class="character-count" [ngClass]="getCharacterCountStatus('useOfMachinery')">
          {{ getCharacterCountDisplay('useOfMachinery') }}
        </div> -->
        <!-- <ion-text *ngIf="shouldShowError('useOfMachinery') && useOfMachinery?.hasError('required')" color="danger">
          Required
        </ion-text> -->
        <ion-text *ngIf="hasCharacterLimitWarning('useOfMachinery')" color="warning" class="character-warning">
          {{ getCharacterLimitMessage('useOfMachinery') }}
        </ion-text>
      </div>
    </div>

    <label class="label-header-class">{{ 'user_details' | translate }}</label>
    <div class="user-details-container" formArrayName="userRoles">
      <div *ngFor="let userRole of userRoles.controls; let i = index" class="user-role-item" [formGroupName]="i">
        <div class="form-grid-container">
          <div class="form-column-left">
            <ion-label class="label-class"> {{ 'user_role' | translate }} </ion-label>
            <ion-input placeholder="{{'add_user_role' | translate}}" maxlength="150" formControlName="userRole"
              class="user-role-field">
            </ion-input>
            <ion-text *ngIf="hasUserRoleCharacterLimitWarning(i, 'userRole')" color="warning" color="danger">
              {{ getUserRoleCharacterLimitMessage(i, 'userRole') }}
            </ion-text>
            <div class="character-count" [ngClass]="getCharacterCountStatus('userRole')">
              {{ getUserRoleCharacterCount(i, 'userRole') }}/150
            </div>
          </div>
          <div class="form-column-right">
            <div class="textarea-container">
              <ion-label class="label-class"> {{ 'user_details_lbl' | translate }} </ion-label>
              <div class="textarea-with-icon">
                <app-ai-writing-field-shell formControlName="userDetails" class="ai-text-area-block" title="{{ 'user_details' | translate }}" placeholder="{{'enter_description' | translate}}" fieldContextType="machine-limit-description" [historyKey]="'machine-limit::' + machineId + '::userDetails::' + i"></app-ai-writing-field-shell>
                <img src="../../../assets/icon/close_icon.svg" *ngIf="canDeleteUserRole(i)"       keyboardCloseIcon 
                tooltip="{{ 'Remove' | translate }}" class="delete-icon" alt="delete icon" (click)="deleteUserRole(i)">
              </div>
              <ion-text *ngIf="hasUserRoleCharacterLimitWarning(i, 'userDetails')" color="warning"
                class="character-warning">
                {{ getUserRoleCharacterLimitMessage(i, 'userDetails') }}
              </ion-text>
            </div>
          </div>
        </div>
      </div>

      <div class="user-btn">
        <ion-button class="app-btn user-role-button" shape="round" fill="outline" color="primary"
          (click)="addNewUserRole()">
          <ion-icon slot="start" name='add-circle-outline'></ion-icon>
          {{'new_user_role'|translate}}
        </ion-button>
      </div>
    </div>

    <div class="form-grid-container">
      <div class="form-column-left">
        <ion-label class="label-class"> {{ 'exposure_of_other_persons' | translate }} </ion-label>
        <div class="resizable-textarea">
          <app-ai-writing-field-shell formControlName="exposure" class="ai-text-area-block" title="{{ 'exposure_of_other_persons' | translate }}" placeholder="{{'enter_description' | translate}}" fieldContextType="machine-limit-description" [historyKey]="'machine-limit::' + machineId + '::exposure'"></app-ai-writing-field-shell>
        </div>
        <ion-text *ngIf="hasCharacterLimitWarning('exposure')" color="warning" class="character-warning">
          {{ getCharacterLimitMessage('exposure') }}
        </ion-text>
      </div>
      <div class="form-column-right">
        <ion-label class="label-class"> {{ 'number_of_operators' | translate }} </ion-label>
        <ion-input placeholder="{{'enter_no_of_operators' | translate}}" maxlength="4"
          formControlName="numberOfOperators" class="felid-input">
        </ion-input>
        <ion-text *ngIf="shouldShowError('numberOfOperators')" color="danger">
          {{'only_numbers_allowed_msg' | translate}}
        </ion-text>
        <div class="character-count" [ngClass]="getCharacterCountStatus('numberOfOperators')">
          {{ getCharacterCountDisplay('numberOfOperators') }}/4
        </div>
      </div>
    </div>
    <div class="form-grid-container">
      <div class="form-column-left">
        <ion-label class="label-class"> {{ 'other_use_limit' | translate }} </ion-label>
        <app-ai-writing-field-shell formControlName="otherUseLimit" class="ai-text-area-block" title="{{ 'other_use_limit' | translate }}" placeholder="{{'enter_description' | translate}}" fieldContextType="machine-limit-description" [historyKey]="'machine-limit::' + machineId + '::otherUseLimit'"></app-ai-writing-field-shell>
        <ion-text *ngIf="hasCharacterLimitWarning('otherUseLimit')" color="warning" class="character-warning">
          {{ getCharacterLimitMessage('otherUseLimit') }}
        </ion-text>
      </div>
      <div class="form-column-right">
      </div>
    </div>

    <div class="section-block">
      <div class="section-header">
        <span class="section-title">{{'space_limits' | translate}}</span>
        <div class="section-line"></div>
      </div>
    </div>

    <div class="form-grid-container">
      <div class="form-column-left">
        <ion-label class="label-class"> {{ 'machine_size' | translate }} </ion-label>
        <ion-input placeholder="{{'add_machine_size' | translate}}" maxlength="150" formControlName="machineSize"
          class="felid-input">
        </ion-input>
        <ion-text *ngIf="hasCharacterLimitWarning('machineSize')" color="danger">
          {{ getCharacterLimitMessage('machineSize') }}
        </ion-text>
        <div class="character-count" [ngClass]="getCharacterCountStatus('machineSize')">
          {{ getCharacterCountDisplay('machineSize') }}/150
        </div>
      </div>
      <div class="form-column-right">
        <ion-label class="label-class"> {{ 'human_interaction' | translate }} </ion-label>
        <app-ai-writing-field-shell formControlName="humanInteraction" class="ai-text-area-block" title="{{ 'human_interaction' | translate }}" placeholder="{{'enter_description' | translate}}" fieldContextType="machine-limit-description" [historyKey]="'machine-limit::' + machineId + '::humanInteraction'"></app-ai-writing-field-shell>
        <ion-text *ngIf="hasCharacterLimitWarning('humanInteraction')" color="warning" class="character-warning">
          {{ getCharacterLimitMessage('humanInteraction') }}
        </ion-text>
      </div>
    </div>

    <div class="form-grid-container">
      <div class="form-column-left">
        <ion-label class="label-class"> {{ 'power_supply_interface' | translate }} </ion-label>
        <app-ai-writing-field-shell formControlName="powerSupplyInterface" class="ai-text-area-block" title="{{ 'power_supply_interface' | translate }}" placeholder="{{'enter_description' | translate}}" fieldContextType="machine-limit-description" [historyKey]="'machine-limit::' + machineId + '::powerSupplyInterface'"></app-ai-writing-field-shell>
        <ion-text *ngIf="hasCharacterLimitWarning('powerSupplyInterface')" color="warning" class="character-warning">
          {{ getCharacterLimitMessage('powerSupplyInterface') }}
        </ion-text>
      </div>
      <div class="form-column-right">
        <ion-label class="label-class"> {{ 'other_space_limit' | translate }} </ion-label>
        <app-ai-writing-field-shell formControlName="otherSpaceLimit" class="ai-text-area-block" title="{{ 'other_space_limit' | translate }}" placeholder="{{'enter_description' | translate}}" fieldContextType="machine-limit-description" [historyKey]="'machine-limit::' + machineId + '::otherSpaceLimit'"></app-ai-writing-field-shell>
        <ion-text *ngIf="hasCharacterLimitWarning('otherSpaceLimit')" color="warning" class="character-warning">
          {{ getCharacterLimitMessage('otherSpaceLimit') }}
        </ion-text>
      </div>
    </div>

    <div class="section-block">
      <div class="section-header">
        <span class="section-title">{{'time_limits' | translate}}</span>
        <div class="section-line"></div>
      </div>
    </div>

    <div class="form-grid-container">
      <div class="form-column-left">
        <ion-label class="label-class"> {{ 'life_of_machinery' | translate }} </ion-label>
        <app-ai-writing-field-shell formControlName="lifeOfMachinery" class="ai-text-area-block" title="{{ 'life_of_machinery' | translate }}" placeholder="{{'enter_description' | translate}}" fieldContextType="machine-limit-description" [historyKey]="'machine-limit::' + machineId + '::lifeOfMachinery'"></app-ai-writing-field-shell>
        <ion-text *ngIf="hasCharacterLimitWarning('lifeOfMachinery')" color="warning" class="character-warning">
          {{ getCharacterLimitMessage('lifeOfMachinery') }}
        </ion-text>
      </div>
      <div class="form-column-right">
        <ion-label class="label-class"> {{ 'other_time_limit' | translate }} </ion-label>
        <app-ai-writing-field-shell formControlName="otherTimeLimit" class="ai-text-area-block" title="{{ 'other_time_limit' | translate }}" placeholder="{{'enter_description' | translate}}" fieldContextType="machine-limit-description" [historyKey]="'machine-limit::' + machineId + '::otherTimeLimit'"></app-ai-writing-field-shell>
        <ion-text *ngIf="hasCharacterLimitWarning('otherTimeLimit')" color="warning" class="character-warning">
          {{ getCharacterLimitMessage('otherTimeLimit') }}
        </ion-text>
      </div>
    </div>

    <div class="form-grid-container">
      <div class="form-column-left">
        <ion-label class="label-class"> {{ 'recommended_service_interval' | translate }} </ion-label>
        <app-ai-writing-field-shell formControlName="recommendedServiceInterval" class="ai-text-area-block" title="{{ 'recommended_service_interval' | translate }}" placeholder="{{'enter_description' | translate}}" fieldContextType="machine-limit-description" [historyKey]="'machine-limit::' + machineId + '::recommendedServiceInterval'"></app-ai-writing-field-shell>
        <ion-text *ngIf="hasCharacterLimitWarning('recommendedServiceInterval')" color="warning"
          class="character-warning">
          {{ getCharacterLimitMessage('recommendedServiceInterval') }}
        </ion-text>
      </div>
      <div class="form-column-right"></div>
    </div>

    <div class="section-block">
      <div class="section-header">
        <span class="section-title">{{'other_limits' | translate}}</span>
        <div class="section-line"></div>
      </div>
    </div>

    <div class="form-grid-container">
      <div class="form-column-left">
        <ion-label class="label-class"> {{ 'properties_of_materials_to_process' | translate }} </ion-label>
        <app-ai-writing-field-shell formControlName="propertiesOfMaterialsToProcess" class="ai-text-area-block" title="{{ 'properties_of_materials_to_process' | translate }}" placeholder="{{'enter_description' | translate}}" fieldContextType="machine-limit-description" [historyKey]="'machine-limit::' + machineId + '::propertiesOfMaterialsToProcess'"></app-ai-writing-field-shell>
        <ion-text *ngIf="hasCharacterLimitWarning('propertiesOfMaterialsToProcess')" color="warning"
          class="character-warning">
          {{ getCharacterLimitMessage('propertiesOfMaterialsToProcess') }}
        </ion-text>
      </div>
      <div class="form-column-right">
        <ion-label class="label-class"> {{ 'level_of_cleanliness' | translate }} </ion-label>
        <app-ai-writing-field-shell formControlName="levelOfCleanliness" class="ai-text-area-block" title="{{ 'level_of_cleanliness' | translate }}" placeholder="{{'enter_description' | translate}}" fieldContextType="machine-limit-description" [historyKey]="'machine-limit::' + machineId + '::levelOfCleanliness'"></app-ai-writing-field-shell>
        <ion-text *ngIf="hasCharacterLimitWarning('levelOfCleanliness')" color="warning" class="character-warning">
          {{ getCharacterLimitMessage('levelOfCleanliness') }}
        </ion-text>
      </div>
    </div>

    <div class="form-grid-container">
      <div class="form-column-left">
        <ion-label class="label-class"> {{ 'environmental_conditions' | translate }} </ion-label>
        <app-ai-writing-field-shell formControlName="environmentalConditions" class="ai-text-area-block" title="{{ 'environmental_conditions' | translate }}" placeholder="{{'enter_description' | translate}}" fieldContextType="machine-limit-description" [historyKey]="'machine-limit::' + machineId + '::environmentalConditions'"></app-ai-writing-field-shell>
        <ion-text *ngIf="hasCharacterLimitWarning('environmentalConditions')" color="warning" class="character-warning">
          {{ getCharacterLimitMessage('environmentalConditions') }}
        </ion-text>
      </div>
      <div class="form-column-right">
        <ion-label class="label-class"> {{ 'other' | translate }} </ion-label>
        <app-ai-writing-field-shell formControlName="other" class="ai-text-area-block" title="{{ 'other' | translate }}" placeholder="{{'enter_description' | translate}}" fieldContextType="machine-limit-description" [historyKey]="'machine-limit::' + machineId + '::other'"></app-ai-writing-field-shell>
        <ion-text *ngIf="hasCharacterLimitWarning('other')" color="warning" class="character-warning">
          {{ getCharacterLimitMessage('other') }}
        </ion-text>
      </div>
    </div>

    <div class="user-details-container" formArrayName="otherLimits">
      <div *ngFor="let otherLimit of otherLimits.controls; let i = index" class="user-role-item" [formGroupName]="i">
        <div class="form-grid-container">
          <div class="form-column-left">
            <ion-label class="label-class"> {{ 'other_limit_field_name' | translate }} </ion-label>
            <ion-input placeholder="{{'enter_other_limit_field_name' | translate}}" maxlength="150" 
              formControlName="otherLimitFieldName" 
              class="user-role-field"
              (input)="onInputRestriction($event, 150)">
            </ion-input>
            <ion-text *ngIf="hasOtherLimitCharacterLimitWarning(i, 'otherLimitFieldName')" color="warning" class="character-warning">
              {{ getOtherLimitCharacterLimitMessage(i, 'otherLimitFieldName') }}
            </ion-text>
            <div class="character-count" [ngClass]="getOtherLimitCharacterStatus(i, 'otherLimitFieldName')">
              {{ getOtherLimitCharacterCount(i, 'otherLimitFieldName') }}/150
            </div>
          </div>
          <div class="form-column-right">
            <div class="textarea-container">
              <ion-label class="label-class"> {{ 'description' | translate }} </ion-label>
              <div class="textarea-with-icon">
                <app-ai-writing-field-shell formControlName="description" class="ai-text-area-block" title="{{ 'description' | translate }}" placeholder="{{'enter_description' | translate}}" [maxlength]="2000" fieldContextType="machine-limit-description" [historyKey]="'machine-limit::' + machineId + '::otherLimit::' + i"></app-ai-writing-field-shell>
                <img src="../../../assets/icon/close_icon.svg" *ngIf="canDeleteOtherLimit(i)"   keyboardCloseIcon     
                tooltip="{{ 'Remove' | translate }}" class="delete-icon" alt="delete icon" (click)="deleteOtherLimit(i)">
              </div>
              <ion-text *ngIf="hasOtherLimitCharacterLimitWarning(i, 'description')" color="warning" class="character-warning">
                {{ getOtherLimitCharacterLimitMessage(i, 'description') }}
              </ion-text>
            </div>
          </div>
        </div>
      </div>

      <div class="user-btn">
        <ion-button class="app-btn user-role-button" shape="round" fill="outline" color="primary"
          (click)="addNewOtherLimit()">
          <ion-icon slot="start" name='add-circle-outline'></ion-icon>
          {{'new_limit'|translate}}
        </ion-button>
      </div>
    </div>

    <div class="form-grid-container">
      <div class="form-column-left">
        <ion-label class="label-class"> {{ 'phase_of_machine_life_cycle' | translate }} </ion-label>
        <app-ai-writing-field-shell formControlName="phaseOfMachineLifeCycle" class="ai-text-area-block" title="{{ 'phase_of_machine_life_cycle' | translate }}" placeholder="{{'enter_description' | translate}}" fieldContextType="machine-limit-description" [historyKey]="'machine-limit::' + machineId + '::phaseOfMachineLifeCycle'"></app-ai-writing-field-shell>
        <ion-text *ngIf="hasCharacterLimitWarning('phaseOfMachineLifeCycle')" color="warning" class="character-warning">
          {{ getCharacterLimitMessage('phaseOfMachineLifeCycle') }}
        </ion-text>
      </div>
      <div class="form-column-right">
      </div>
    </div>
    </div>
  </div>
</form>

<!-- Read-Only View -->
<div class="machine-limit-container" *ngIf="isReadOnlyMode">
  <div class="button-container" style="display: flex; align-items: center; gap: 10px;">     
      <ion-button class="app-btn" *ngIf="!isCloneMode" shape="round" fill="outline" color="primary" (click)="enableEditMode()"> 
        {{ 'Edit' | translate }} 
       </ion-button> 
  </div>
  <div class="machine-limit-block">
    <div class="section-block">
      <div class="section-header">
        <span class="section-title">{{'use_limits' | translate}}</span>
        <div class="section-line"></div>
      </div>
    </div>
    <div class="form-grid-container">
      <div class="form-column-left">
        <ion-label class="label-class"> {{ 'Machine Mode' | translate }} *</ion-label>
        <div class="readonly-value">
          <span *ngIf="selectedMachineModes; else noMachineModes">
            <span *ngFor="let mode of selectedMachineModes" class="machine-readonly-mode">
              <span tooltip="{{mode}}" placement="bottom">{{ mode }}</span>
            </span>
          </span>
          <ng-template #noMachineModes>
            <span class="no-data">{{'not_available' | translate}}</span>
          </ng-template>
        </div>
      </div>
      <div class="form-column-right">
        <ion-label class="label-class"> {{ 'use_of_machinery' | translate }} </ion-label>
        <div class="readonly-value">
          <p *ngIf="machineLimitForm?.get('useOfMachinery')?.value; else noUseOfMachinery">
            {{ machineLimitForm?.get('useOfMachinery')?.value }}
          </p>
          <ng-template #noUseOfMachinery>
            <span class="no-data">{{'not_available' | translate}}</span>
          </ng-template>
        </div>
      </div>
    </div>

    <label class="label-header-class">{{ 'user_details' | translate }}</label>
    <div class="user-details-container">
      <div *ngFor="let userRole of userRoles.controls; let i = index" class="user-role-item">
        <div class="form-grid-container">
          <div class="form-column-left">
            <ion-label class="label-class"> {{ 'user_role' | translate }} </ion-label>
            <div class="readonly-value">
              <p *ngIf="getUserRoleValue(i, 'userRole'); else noUserRole">
                {{ getUserRoleValue(i, 'userRole') }}
              </p>
              <ng-template #noUserRole>
                <span class="no-data">{{'not_available' | translate}}</span>
              </ng-template>
            </div>
          </div>
          <div class="form-column-right">
            <ion-label class="label-class"> {{ 'user_details_lbl' | translate }} </ion-label>
            <div class="readonly-value">
              <p *ngIf="getUserRoleValue(i, 'userDetails'); else noUserDetails">
                {{ getUserRoleValue(i, 'userDetails') }}
              </p>
              <ng-template #noUserDetails>
                <span class="no-data">{{'not_available' | translate}}</span>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="form-grid-container">
      <div class="form-column-left">
        <ion-label class="label-class"> {{ 'exposure_of_other_persons' | translate }} </ion-label>
        <div class="readonly-value">
          <p *ngIf="machineLimitForm?.get('exposure')?.value; else noExposure">
            {{ machineLimitForm?.get('exposure')?.value }}
          </p>
          <ng-template #noExposure>
            <span class="no-data">{{'not_available' | translate}}</span>
          </ng-template>
        </div>
      </div>
      <div class="form-column-right">
        <ion-label class="label-class"> {{ 'number_of_operators' | translate }} </ion-label>
        <div class="readonly-value">
          <p *ngIf="machineLimitForm?.get('numberOfOperators')?.value; else noOperators">
            {{ machineLimitForm?.get('numberOfOperators')?.value }}
          </p>
          <ng-template #noOperators>
            <span class="no-data">{{'not_available' | translate}}</span>
          </ng-template>
        </div>
      </div>
    </div>
    <div class="form-grid-container">
      <div class="form-column-left">
        <ion-label class="label-class"> {{ 'other_use_limit' | translate }} </ion-label>
        <div class="readonly-value">
          <p *ngIf="machineLimitForm?.get('otherUseLimit')?.value; else noOtherUseLimit">
            {{ machineLimitForm?.get('otherUseLimit')?.value }}
          </p>
          <ng-template #noOtherUseLimit>
            <span class="no-data">{{'not_available' | translate}}</span>
          </ng-template>
        </div>
      </div>
      <div class="form-column-right">
      </div>
    </div>

    <div class="section-block">
      <div class="section-header">
        <span class="section-title">{{'space_limits' | translate}}</span>
        <div class="section-line"></div>
      </div>
    </div>

    <div class="form-grid-container">
      <div class="form-column-left">
        <ion-label class="label-class"> {{ 'machine_size' | translate }} </ion-label>
        <div class="readonly-value">
          <p *ngIf="machineLimitForm?.get('machineSize')?.value; else noMachineSize">
            {{ machineLimitForm?.get('machineSize')?.value }}
          </p>
          <ng-template #noMachineSize>
            <span class="no-data">{{'not_available' | translate}}</span>
          </ng-template>
        </div>
      </div>
      <div class="form-column-right">
        <ion-label class="label-class"> {{ 'human_interaction' | translate }} </ion-label>
        <div class="readonly-value">
          <p *ngIf="machineLimitForm?.get('humanInteraction')?.value; else noHumanInteraction">
            {{ machineLimitForm?.get('humanInteraction')?.value }}
          </p>
          <ng-template #noHumanInteraction>
            <span class="no-data">{{'not_available' | translate}}</span>
          </ng-template>
        </div>
      </div>
    </div>

    <div class="form-grid-container">
      <div class="form-column-left">
        <ion-label class="label-class"> {{ 'power_supply_interface' | translate }} </ion-label>
        <div class="readonly-value">
          <p *ngIf="machineLimitForm?.get('powerSupplyInterface')?.value; else noPowerSupply">
            {{ machineLimitForm?.get('powerSupplyInterface')?.value }}
          </p>
          <ng-template #noPowerSupply>
            <span class="no-data">{{'not_available' | translate}}</span>
          </ng-template>
        </div>
      </div>
      <div class="form-column-right">
        <ion-label class="label-class"> {{ 'other_space_limit' | translate }} </ion-label>
        <div class="readonly-value">
          <p *ngIf="machineLimitForm?.get('otherSpaceLimit')?.value; else noOtherSpaceLimit">
            {{ machineLimitForm?.get('otherSpaceLimit')?.value }}
          </p>
          <ng-template #noOtherSpaceLimit>
            <span class="no-data">{{'not_available' | translate}}</span>
          </ng-template>
        </div>
      </div>
    </div>

    <div class="section-block">
      <div class="section-header">
        <span class="section-title">{{'time_limits' | translate}}</span>
        <div class="section-line"></div>
      </div>
    </div>

    <div class="form-grid-container">
      <div class="form-column-left">
        <ion-label class="label-class"> {{ 'life_of_machinery' | translate }} </ion-label>
        <div class="readonly-value">
          <p *ngIf="machineLimitForm?.get('lifeOfMachinery')?.value; else noLifeOfMachinery">
            {{ machineLimitForm?.get('lifeOfMachinery')?.value }}
          </p>
          <ng-template #noLifeOfMachinery>
            <span class="no-data">{{'not_available' | translate}}</span>
          </ng-template>
        </div>
      </div>
      <div class="form-column-right">
        <ion-label class="label-class"> {{ 'other_time_limit' | translate }} </ion-label>
        <div class="readonly-value">
          <p *ngIf="machineLimitForm?.get('otherTimeLimit')?.value; else noOtherTimeLimit">
            {{ machineLimitForm?.get('otherTimeLimit')?.value }}
          </p>
          <ng-template #noOtherTimeLimit>
            <span class="no-data">{{'not_available' | translate}}</span>
          </ng-template>
        </div>
      </div>
    </div>

    <div class="form-grid-container">
      <div class="form-column-left">
        <ion-label class="label-class"> {{ 'recommended_service_interval' | translate }} </ion-label>
        <div class="readonly-value">
          <p *ngIf="machineLimitForm?.get('recommendedServiceInterval')?.value; else noServiceInterval">
            {{ machineLimitForm?.get('recommendedServiceInterval')?.value }}
          </p>
          <ng-template #noServiceInterval>
            <span class="no-data">{{'not_available' | translate}}</span>
          </ng-template>
        </div>
      </div>
      <div class="form-column-right"></div>
    </div>

    <div class="section-block">
      <div class="section-header">
        <span class="section-title">{{'other_limits' | translate}}</span>
        <div class="section-line"></div>
      </div>
    </div>

    <div class="form-grid-container">
      <div class="form-column-left">
        <ion-label class="label-class"> {{ 'properties_of_materials_to_process' | translate }} </ion-label>
        <div class="readonly-value">
          <p *ngIf="machineLimitForm?.get('propertiesOfMaterialsToProcess')?.value; else noProperties">
            {{ machineLimitForm?.get('propertiesOfMaterialsToProcess')?.value }}
          </p>
          <ng-template #noProperties>
            <span class="no-data">{{'not_available' | translate}}</span>
          </ng-template>
        </div>
      </div>
      <div class="form-column-right">
        <ion-label class="label-class"> {{ 'level_of_cleanliness' | translate }} </ion-label>
        <div class="readonly-value">
          <p *ngIf="machineLimitForm?.get('levelOfCleanliness')?.value; else noCleanliness">
            {{ machineLimitForm?.get('levelOfCleanliness')?.value }}
          </p>
          <ng-template #noCleanliness>
            <span class="no-data">{{'not_available' | translate}}</span>
          </ng-template>
        </div>
      </div>
    </div>

    <div class="form-grid-container">
      <div class="form-column-left">
        <ion-label class="label-class"> {{ 'environmental_conditions' | translate }} </ion-label>
        <div class="readonly-value">
          <p *ngIf="machineLimitForm?.get('environmentalConditions')?.value; else noEnvironmental">
            {{ machineLimitForm?.get('environmentalConditions')?.value }}
          </p>
          <ng-template #noEnvironmental>
            <span class="no-data">{{'not_available' | translate}}</span>
          </ng-template>
        </div>
      </div>
      <div class="form-column-right">
        <ion-label class="label-class"> {{ 'other' | translate }} </ion-label>
        <div class="readonly-value">
          <p *ngIf="machineLimitForm?.get('other')?.value; else noOther">
            {{ machineLimitForm?.get('other')?.value }}
          </p>
          <ng-template #noOther>
            <span class="no-data">{{'not_available' | translate}}</span>
          </ng-template>
        </div>
      </div>
    </div>

    <div class="user-details-container">
      <div *ngFor="let otherLimit of otherLimits.controls; let i = index" class="user-role-item">
        <div class="form-grid-container">
          <div class="form-column-left">
            <ion-label class="label-class"> {{ 'other_limit_field_name' | translate }} </ion-label>
            <div class="readonly-value">
              <p *ngIf="getOtherLimitValue(i, 'otherLimitFieldName'); else noOtherLimitName">
                {{ getOtherLimitValue(i, 'otherLimitFieldName') }}
              </p>
              <ng-template #noOtherLimitName>
                <span class="no-data">{{'not_available' | translate}}</span>
              </ng-template>
            </div>
          </div>
          <div class="form-column-right">
            <ion-label class="label-class"> {{ 'description' | translate }} </ion-label>
            <div class="readonly-value">
              <p *ngIf="getOtherLimitValue(i, 'description'); else noOtherLimitDesc">
                {{ getOtherLimitValue(i, 'description') }}
              </p>
              <ng-template #noOtherLimitDesc>
                <span class="no-data">{{'not_available' | translate}}</span>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="form-grid-container">
      <div class="form-column-left">
        <ion-label class="label-class"> {{ 'phase_of_machine_life_cycle' | translate }} </ion-label>
        <div class="readonly-value">
          <p *ngIf="machineLimitForm?.get('phaseOfMachineLifeCycle')?.value; else noPhase">
            {{ machineLimitForm?.get('phaseOfMachineLifeCycle')?.value }}
          </p>
          <ng-template #noPhase>
            <span class="no-data">{{'not_available' | translate}}</span>
          </ng-template>
        </div>
      </div>
      <div class="form-column-right">
      </div>
    </div>
  </div>
</div>